import React from 'react';
import { ReactComponent as Avatar1 } from './avatar1.svg';
import { ReactComponent as Avatar2 } from './avatar2.svg';
import { ReactComponent as Avatar3 } from './avatar3.svg';
import { ReactComponent as Avatar4 } from './avatar4.svg';
import { ReactComponent as Avatar5 } from './avatar5.svg';
import { ReactComponent as Avatar6 } from './avatar6.svg';
import { AvatarImageContainer } from '@sections/find/HeroSection/components/ResultListItem/ResultListItem.styles';

type PlaceholderAvatarProps = {
  avatarIndex: number;
};

export const PlaceholderAvatar = (props: PlaceholderAvatarProps) => {
  const avatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5, Avatar6];
  return <AvatarImageContainer>{avatars[props.avatarIndex]()}</AvatarImageContainer>;
};
